import { Portal } from 'solid-js/web';
import { StyledSmallCornerDialog, StyledSmallCornerDialogWrapper } from './small-corner-dialog.style';

export const SmallCornerDialog = (props: any) => {
    return (
        <Portal mount={document.getElementById('root')!}>
            <StyledSmallCornerDialogWrapper>
                <StyledSmallCornerDialog>
                    {props.children}
                </StyledSmallCornerDialog>
            </StyledSmallCornerDialogWrapper>
        </Portal>
    );
};
